import { FaMapMarkerAlt, FaArrowUp, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { useEffect, useState } from "react";

const Footer = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer
      id="contact"
      className="bg-gradient-to-r from-teal-950 to-green-700 text-white py-10 px-6 relative"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 text-center md:text-left">
        {/* Address Section */}
        <div className="space-y-4">
          <h3 className="text-2xl font-bold mb-2">Our Locations</h3>
          <div className="flex flex-col items-center md:items-start gap-3">
            {/* <FaMapMarkerAlt className="text-xl text-green-300" /> */}
            <p>
              <strong>Zimbabwe:</strong> 7 Richmond Close, Highlands, Harare
              <br />
              <strong>Malawi:</strong> Let's Trade Africa, Plot No 5/114 P.O Box 20558, Lilongwe
            </p>
          </div>
        </div>

        {/* Contact Section */}
        <div className="space-y-4">
          <h3 className="text-2xl font-bold mb-2">Contact Us</h3>
          <div className="flex flex-col items-center md:items-start gap-3">
            <div className="flex items-center gap-3">
              <FaPhoneAlt className="text-lg text-green-300" />
              <span>+263 242 498460</span>
            </div>
            <div className="flex items-center gap-3">
              <FaEnvelope className="text-lg text-green-300" />
              <span>info@letstrade.africa</span>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      {showButton && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-3 rounded-full shadow-xl transition-all duration-300 z-50"
          aria-label="Back to top"
        >
          <FaArrowUp className="text-xl" />
        </button>
      )}

      {/* Footer Bottom */}
      <div className="mt-10 text-center text-sm text-green-100 border-t border-green-600 pt-4">
        © {new Date().getFullYear()} Let's Trade Africa. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
